import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import PageWrapper from '/components/page-wrapper'

import HelpText from '/help/account-management-delete'
import { AppContext } from '/providers/app-context'

import Menu from '/components/account/nav-menu'
import DeleteAdmin from '/components/account/delete'

const AccountManagementDelete = () => {

  const navigate = useNavigate()

  const { client, user } = useContext(AppContext)

  if (!user?.permissions.client_admin) navigate("../password")

  return (
    <PageWrapper title="Delete Your Account" HelpText={HelpText} heading="Delete Your Account" menu={<Menu client={client} user={user}/>}>
      <div className='flex flex-col gap-5 overflow-y-scroll p-5'>
        <DeleteAdmin />
      </div>
    </PageWrapper>
  )
}

export default AccountManagementDelete